import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const What3wordsTooltip = ({ tooltipText }) => {
  return tooltipText ? (
    <Box
      backgroundColor="primaryText"
      data-name="what3words-tooltip"
      borderRadius="5px"
      horizontal
      padding="10px"
    >
      <Text
        color="background"
        data-name="what3words-tooltip-text"
        noWrap
        size="small"
      >
        ///{tooltipText}
      </Text>
    </Box>
  ) : null;
};

export default What3wordsTooltip;
